import CircuitBreaker from 'opossum'

export const createCircuit = (func, options) => {
  return new CircuitBreaker(func, options)
}
